import { Controller } from '@hotwired/stimulus'
import { toggle } from '../../lib/dom'

export default class extends Controller {
  static targets = ['container', 'left', 'right', 'item']

  connect() {
    setTimeout(() => this.toggleButtons(), 100)
  }

  itemTargetConnected(item) {
    if (item.dataset.active === 'true') {
      setTimeout(() => this.scrollToItem(item), 100)
    }
  }

  scrollToItem(item) {
    const { offsetLeft, clientWidth } = item

    if (!this.overflowing || offsetLeft <= clientWidth * 3) return

    this.containerTarget.scrollBy({
      left: offsetLeft - clientWidth / 2,
      behavior: 'smooth',
    })
  }

  scroll(direction) {
    const left = this.scrollFactor * direction

    this.containerTarget.scrollBy({ left, behavior: 'smooth' })
  }

  scrollLeft() {
    this.scroll(-1)
  }

  scrollRight() {
    this.scroll(1)
  }

  toggleButtons() {
    const { scrollWidth, clientWidth, scrollLeft } = this.containerTarget

    toggle(this.leftTarget, this.overflowing && scrollLeft > 0)
    toggle(
      this.rightTarget,
      this.overflowing && scrollLeft + clientWidth < scrollWidth
    )
  }

  get overflowing() {
    const { scrollWidth, clientWidth } = this.containerTarget

    return scrollWidth > clientWidth
  }

  get scrollFactor() {
    if (this.itemTargets.length === 0) return 0

    return this.itemTargets[0].offsetWidth * 3
  }
}
